module.exports = __webpack_public_path__ + "static/media/bg-chat-tile-light.04fcacde.png";